const { PI } = Math

export const START_AT_RIGHT = 0
export const START_AT_BOTTOM = (1 / 2) * PI
export const START_AT_LEFT = PI
export const START_AT_TOP = (3 / 2) * PI

export const CLOCKWISE = 1
export const COUNTER_CLOCKWISE = 0

export const MAX_ARC_PROPORTION = 0.999
